import React, { Component } from "react"
import { FormControl, FormGroup } from "react-bootstrap"

export default class FormSelectWrapper extends Component {
	propTypes: {
		id: React.PropTypes.string.isRequired,
		label: React.PropTypes.string,
		selectOptions: React.PropTypes.array,
		defaultValue: React.PropTypes.string,
		parentChange: React.PropTypes.func,
	}

	constructor(props) {
		super(props)
		const { defaultValue } = this.props
		this.state = {
			value: defaultValue || "",
		}
	}

	handleChange = e => {
		this.setState({ value: e.target.value })
	}

	getData = () => {
		return this.state.value
	}

	render() {
		const { id, parentChange, selectOptions } = this.props
		const options = selectOptions.map(op => (
			<option key={op.key} value={op.value}>
				{op.label}
			</option>
		))
		const onChange = e => {
			this.handleChange(e)
			if (parentChange) parentChange(e)
		}
		return (
			<FormGroup>
				<FormControl
					id={id}
					value={this.state.value}
					componentClass="select"
					onChange={onChange}
					ref="localValue"
				>
					{options}
				</FormControl>
			</FormGroup>
		)
	}
}



// WEBPACK FOOTER //
// ./src/forms/FormSelectWrapper.js